import React from 'react'
import moment from 'moment'

const UserSummary = ({user}) => {
  return (
    <div className="card z-depth-0 project-summary">
      <div className="card-content grey-text text-darken-3">
        <span className="card-title ">{user.firstName} {user.lastName}</span>
        <p className="grey-text">{user.email}</p>
        <p className="grey-text">{user.phone}</p>
        <p className="grey-text">Assignments : {user.assignmentLabels}</p>
       
      </div>
    </div>
  )
}

export default UserSummary



// WEBPACK FOOTER //
// ./src/components/users/UserSummary.js